<template>
  <div v-if="0 !== getChildren(category).length" class="children-list">
    <MyLink
      v-for="childCategory in getChildren(category)"
      :key="childCategory.id"
      class="children-list__item"
      :class="{ isListShown }"
      name="category"
      :params="{
        categorySlug: childCategory.slug,
      }"
    >
      {{ childCategory.getName() }}
    </MyLink>
    <button
      v-if="getChildren(category).length > 4"
      class="children-list__show-more"
      @click.prevent="onShowList"
    >
      {{ isListShown ? _T("@Hide") : _T("@Show more") }}
    </button>
  </div>
</template>

<script setup>
import { useCategoriesStore } from "~/store/categoriesStore";
import { Category } from "~/models/category.model";

const { category } = defineProps({
  category: { type: Category, required: true },
});

const categoriesStore = useCategoriesStore();
const { getChildren } = storeToRefs(categoriesStore);

const isListShown = ref(false);

const onShowList = () => {
  isListShown.value = !isListShown.value;
};
</script>

<style lang="scss" scoped>
.children-list {
  @include flex-container(column, flex-start);

  @include mobile {
    padding-inline: 40px;
  }

  &__item {
    @include font(14, 20);
    padding-block: 8px;

    &:not(.isListShown):nth-child(n + 5) {
      display: none;
    }

    &:hover {
      color: var(--color-primary-base);
    }
  }

  &__show-more {
    cursor: pointer;
    width: max-content;

    align-self: center;

    @include font;
    color: var(--color-primary-base);

    padding: 8px;

    transition: color 0.2s;

    &:hover {
      color: var(--color-primary-dark);
    }
  }
}
</style>
